<!-- Grid View -->

<div *ngIf="isGridValid">
  <!-- Grid View Collection -->
  <label class="bold">{{ 'SHARED.Total' | translate}}: {{collectionTotalCount}} {{ 'SHARED.Item' | translate}}</label>
  <label *ngIf="componentName == 'MyTasks' || componentName == 'SmallUnitsTasks' || componentName == 'CircularTasks'" class="bold">
    , {{ localizedObjectName + '.SortingBy' | translate }}:
    <span style="color: #fc983f;">{{ localizedObjectName + '.' + sortingColumns[1][0] | translate }}</span>
  </label>
  <label *ngIf="(componentName == 'MyTasks' || componentName == 'SmallUnitsTasks' || componentName == 'CircularTasks' ) && sortingColumns[1][0] != sortingColumns[0][0]" class="bold">
    , {{ localizedObjectName + '.ThenSortingBy' | translate }}:
    <span style="color: #fc983f;">{{ localizedObjectName + '.' + sortingColumns[0][0] | translate }}</span>
  </label>
  <div class="table-responsive">
    <table class="table table-bordered table-striped table-services table-sorting">
      <thead>
        <!-- Headers -->
        <tr>
          <th *ngFor="let header of gridHeaders; let h = index;" (click)="sort(header, sortingKeysDir[h].IsAsc)">
            <span class="header-holder">
              <span class="header-title" [class.active-header]="sortingKeysDir[h].isSortingHeader">{{ localizedObjectName + '.' + header | translate }}</span>
              <span class="sorting-arrows" *ngIf="componentName == 'MyTasks' || componentName == 'LongHaulRequestsManagement' || componentName == 'SmallUnitsTasks' || componentName == 'CircularTasks'">
                <span [class.active-sorting]="sortingKeysDir[h].IsUpActive">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 292.362 292.362" style="width: 15px;" xml:space="preserve">
                    <g>
                      <path d="M286.935,197.286L159.028,69.379c-3.613-3.617-7.895-5.424-12.847-5.424s-9.233,1.807-12.85,5.424L5.424,197.286   C1.807,200.9,0,205.184,0,210.132s1.807,9.233,5.424,12.847c3.621,3.617,7.902,5.428,12.85,5.428h255.813   c4.949,0,9.233-1.811,12.848-5.428c3.613-3.613,5.427-7.898,5.427-12.847S290.548,200.9,286.935,197.286z"/>
                    </g>
                  </svg>
                </span>
                <span [class.active-sorting]="sortingKeysDir[h].IsDownActive">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 292.362 292.362" style="width: 15px;" xml:space="preserve">
                    <g>
                      <path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424   C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428   s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/>
                    </g>
                  </svg>
                </span>
              </span>
            </span>
          </th>
          <th *ngIf="HasMenu"></th>
          <th *ngIf="HasMenuButtons"></th>
        </tr>
      </thead>
      <tbody *ngIf="!IsHtml" >
        <!-- Items -->
        <tr *ngFor="let item of gridCollection; let i = index;" [class.hl-row]="item.HasUnreadMessage == true" >

          <td  *ngFor="let header of gridHeaders; let h = index;">

            <!--<a *ngIf="h == 0"   (click)="navigate(item.RequestId, item.Url,item.AppInstanceID, item.ActivityInstanceID)">
              {{getCellText(gridCollection[i][header])}}</a>-->

              <a *ngIf="header == 'RequestNumber'" (click)="navigate(item.RequestId, item.Url, 'details', item.RequestNumber != null ? item.RequestNumber : '',item.AppInstanceID, item.ServiceId,item.SupplierId != null ? item.SupplierId : '',item.ActivityInstanceID, item.ReleaseFormRequestId,item.EtenderCategoryAdmins)">
                <ng-container *ngIf="(item.ServiceId == 30 || item.ServiceId == 31) && item.EunitSignedAdmins?.length > 0; else noTooltip">
                  <span
                    [attr.data-toggle]="tooltip"
                    [attr.data-html]="true"
                    [attr.title]="'Eunit Signed Admins:\n'+(item.EunitSignedAdmins + '').split(',').join('\n')">
                    {{ getCellText(gridCollection[i][header]) }}
                  </span>
                </ng-container>
                
                <ng-template #noTooltip>
                  <span>{{ getCellText(gridCollection[i][header]) }}</span>
                </ng-template></a>
                <span *ngIf="header != 'RequestNumber'"> {{getCellText(gridCollection[i][header])}}</span>

          </td>

          <td *ngIf="HasMenu">
            <div class="showmore-menu" dropdown>
              <button dropdownToggle type="button" class="dropdown-toggle">
                <span class="workspace-icon">
                  <svg viewBox="0 0 60 60" style="width: 18px;" xml:space="preserve">
                    <g>
                      <path d="M30,16c4.411,0,8-3.589,8-8s-3.589-8-8-8s-8,3.589-8,8S25.589,16,30,16z" />
                      <path d="M30,44c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,44,30,44z" />
                      <path d="M30,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,22,30,22z" />
                    </g>
                  </svg>
                </span>
              </button>
              <ul id="dropdown-menu-dividers" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-menu-dividers">
                <ng-container
                *ngTemplateOutlet="customMenuTemplate || defaultMenu ; context: {$implicit: item, menuItems:menuItems}">
              </ng-container>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="IsHtml">
        <!-- Items   (click)="stopPropagation($event);false"-->
        <tr *ngFor="let item of gridCollection; let i = index;" [class.hl-row]="item.HasUnreadMessage == true">
          <td  *ngFor="let header of gridHeaders; let h = index;" [innerHtml]=gridCollection[i][header] ></td>

          <td *ngIf="HasMenu">
            <div class="showmore-menu" dropdown>
              <button dropdownToggle type="button" class="dropdown-toggle">
                <span class="workspace-icon">
                  <svg viewBox="0 0 60 60" style="width: 18px;" xml:space="preserve">
                  <g>
                  <path d="M30,16c4.411,0,8-3.589,8-8s-3.589-8-8-8s-8,3.589-8,8S25.589,16,30,16z" />
                  <path d="M30,44c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,44,30,44z" />
                  <path d="M30,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,22,30,22z" />
                    </g>
                  </svg>
                </span>
              </button>
              <ul id="dropdown-menu-dividers" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-menu-dividers">
                <li role="menuitem" *ngFor="let menuItem of menuItems; let im = index;">
                  <a class="dropdown-item" (click)="navigate(item.RequestId, item.Url, currentLanguage == 'Ar' ? menuItem.TitleAr : menuItem.Title, item.RequestNumber != null ? item.RequestNumber : '')">
                    {{currentLanguage == "Ar" ? menuItem.TitleAr : menuItem.Title}}
                  </a>
                </li>
                <ng-container
                *ngTemplateOutlet="customMenuTemplate || htmlMenuItem ; context: {$implicit: item, menuItems:menuItems}">
              </ng-container>
              </ul>
            </div>
          </td>

          <td *ngIf="HasMenuButtons">
            <div class="showmore-menu" dropdown>
              <button dropdownToggle type="button" class="dropdown-toggle">
                <span class="workspace-icon">
                  <svg viewBox="0 0 60 60" style="width: 18px;" xml:space="preserve">
                  <g>
                  <path d="M30,16c4.411,0,8-3.589,8-8s-3.589-8-8-8s-8,3.589-8,8S25.589,16,30,16z" />
                  <path d="M30,44c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,44,30,44z" />
                  <path d="M30,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,22,30,22z" />
                    </g>
                  </svg>
                </span>
              </button>
              <ul id="dropdown-menu-dividers" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-menu-dividers">
                <li role="menuitem" *ngFor="let menuItem of menuItems; let im = index;">
                  <a class="dropdown-item" (click)="handleClick(item,menuItem)">
                    {{currentLanguage == "Ar" ? menuItem.TitleAr : menuItem.Title}}
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- Paging -->
  <div class="AspNetPagerClass">
    <a class="AspNetPagerPagingButtonsClass" (click)="paginate(1)"><<</a>
    <label *ngIf="showPrevDots">...</label>
    <a *ngFor="let noOfPage of noOfPagesArr; let n = index;" class="AspNetPagerPagingButtonsClass"
    (click)="paginate(noOfPage)" [class.selectedPage]="noOfPage == currentPage" >{{noOfPage}}</a>
    <label *ngIf="showNextDots">...</label>
    <a class="AspNetPagerPagingButtonsClass" (click)="paginate(noOfPages)">>></a>
  </div>
</div>
<div *ngIf="isGridEmpty&&(componentName == 'MyTasks' || componentName == 'SmallUnitsTasks' || componentName == 'CircularTasks')" class="bs-callout bs-callout-info">
  <h4></h4>
  <p>{{ 'SHARED.MY_TASK_NoItems' | translate}}</p>
</div>
<div *ngIf="isGridEmpty&&componentName != 'MyTasks' && componentName != 'SmallUnitsTasks' && componentName != 'CircularTasks'" class="bs-callout bs-callout-info">
  <h4></h4>
  <p>{{ 'SHARED.NoItems' | translate}}</p>
</div>


<ng-template #defaultMenu let-item let-menuItems="menuItems">

    <li role="menuitem" *ngFor="let menuItem of menuItems; let im = index;">
        <a class="dropdown-item"
          (click)="navigate(item.RequestId, item.Url, currentLanguage == 'Ar' ? menuItem.TitleAr : menuItem.Title, item.RequestNumber != null ? item.RequestNumber : '',item.AppInstanceID, item.ServiceId,item.SupplierId != null ? item.SupplierId : '',item.ActivityInstanceID, item.ReleaseFormRequestId,item.EtenderCategoryAdmins)">
          {{currentLanguage == "Ar" ? menuItem.TitleAr : menuItem.Title}}
        </a>
      </li>

</ng-template>

<ng-template #htmlMenuItem let-item let-menuItems="menuItems">

</ng-template>
